<template>
  <div class="container">
    <div class="img" style="height: 500px">
      <img
        src="../assets//image/新闻中心.png"
        alt="新闻中心"
        style="height: 500px"
      />
    </div>
    <div class="title">
      <div class="company_news" @click="scrollToSection('company_news')">
        公司新闻
      </div>
      <div
        class="industry_news"
        @click="scrollToSection('Industry_informations')"
      >
        行业资讯
      </div>
    </div>
    <div class="line"></div>

    <!-- 版心 -->
    <div class="gutter">
      <div class="company_news_1" ref="company_news" id="sectionA">
        <strong>公司新闻</strong>
      </div>
      <div v-for="item in news" :key="item.id">
        <router-link
          :to="'/NewsDetail/' + item.id"
          style="text-decoration: none"
        >
          <div class="new_1">
            <div class="news_img">
              <img src="../assets/image/新闻.jpg" alt="" />
            </div>
            <div class="title_content">
              <div class="news_tit">{{ item.title }}</div>
              <div class="news_describtion" v-html="item.content"></div>
              <div class="news_time">{{ item.updated }}</div>
            </div>
          </div>
        </router-link>
      </div>
      <!-- 分页标记 -->
      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          @currentPage="queryForm.pageNum"
          :page-size="queryForm.pageSize"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>

      <div
        class="company_news_1"
        style="margin-top: 50px"
        ref="Industry_informations"
        id="sectionB"
      >
        <strong>行业资讯</strong>
      </div>
      <div v-for="item in allnews" :key="item.id">
        <router-link
          :to="'/NewsDetail/' + item.id"
          style="text-decoration: none"
        >
          <div class="new_1">
            <div class="news_img">
              <img src="../assets/image/新闻.jpg" alt="" />
            </div>
            <div class="title_content">
              <div class="news_tit">{{ item.title }}</div>
              <div class="news_describtion">
                {{ item.content }}
              </div>
              <div class="news_time">{{ item.updated }}</div>
            </div>
          </div>
        </router-link>
      </div>

      <!-- 分页标记 -->
      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          @currentPage="queryForm.pageNum"
          :page-size="queryForm.pageSize"
          :total="alltotal"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getNewsList } from "@/api";
export default {
  name: "NewsCenter",
  mounted() {
    this.scrollToPosition();
  },
  watch: {
    "$route.query.scrollTo"(newVal) {
      this.scrollToPosition(newVal);
    },
  },
  data() {
    return {
      news: [],
      allnews: [],
      queryForm: {
        query: "",
        query2: "1",
        pageNum: 1,
        pageSize: 4,
      },
      queryallForm: {
        query: "",
        query2: "2",
        pageNum: 1,
        pageSize: 4,
      },
      total: 10,
      alltotal: 10,
    };
  },
  methods: {
    scrollToSection(sectionId) {
      //获取对应内容块的引用
      const section = this.$refs[sectionId];
      if (section) {
        //使用scrollIntoView方法滚动到内容块
        section.scrollIntoView({ behavior: "smooth" });
        //可以在这里添加逻辑来显示小蓝线,例如设置一个data属性来控制样式
        //this.activeTab=sectionId;
      }
    },
    initnews() {
      getNewsList(this.queryForm)
        .then((res) => {
          console.log(res);
          if (res.code === "200") {
            this.total = res.data.total;
            this.news = res.data.records;
          }
        })
        .catch((err) => {
          console.log(err);
        });

      getNewsList(this.queryallForm)
        .then((res) => {
          console.log(res, "reg");
          if (res.code === "200") {
            this.alltotal = res.data.total;
            this.allnews = res.data.records;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    scrollToPosition(section = null) {
      let element = null;
      if (section) {
        element = document.querySelector(`#${section}`);
      } else {
        // 默认滚动到页面顶部
        element = document.body;
      }
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
    handleSizeChange(pageSize) {
      //改变当前页面个数
      this.queryForm.pageNum = 1;
      this.queryForm.pageSize = pageSize;
      this.initnews();
    },
    handleCurrentChange(pageNum) {
      //改变当前页码
      this.queryForm.pageNum = pageNum;
      this.initnews();
    },
  },
  created() {
    this.initnews();
  },
};
</script>

<style scoped>
@media (max-width: 966px) {
  .news_img img {
    display: none;
  }
}
@media (max-width: 966px) {
  .img img {
    display: none;
  }
  .img {
    height: 0px !important;
  }
}
.pagination {
  width: 88%;
  margin: 0 auto;
  text-align: center;
  margin-bottom: 40px;
  margin-top: 45px;
}
.news_time {
  text-align: left;
  font-size: 16px;
  color: #0858e46c;
  font-weight: 700;
}
.news_describtion {
  text-align: left;
  line-height: 40px;
  max-height: 120px;
  margin-top: 5px;
  font-size: 18px;
  position: relative;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.news_describtion:hover {
  color: #00f;
  transition: 0.1s;
}
.news_tit {
  font-size: 20px;
  text-align: left;
  text-decoration: none;
}
.news_tit:hover {
  color: #00f;
  transition: 0.1s;
}
.new_1 {
  display: flex;
  flex-direction: row;
  border: 1px solid #2222221d;
  height: 300px;
  width: 95%;
  margin: 0 auto;
  border-radius: 10px; /* 添加圆角 */
  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.1), 0 4px 8px rgba(0, 0, 0, 0.1); /* 添加内阴影以增强立体感 */
  overflow: hidden; /* 防止内容溢出 */
  transition: transform 0.3s ease, box-shadow 0.3s ease; /* 添加过渡效果 */
  margin-bottom: 100px;
  background-color: #f5f5f5;
  margin-bottom: 30px;
  color: #333;
}

.new_1:hover {
  transform: scale(1.02); /* 鼠标悬停时轻微放大 */
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.2); /* 鼠标悬停时增加阴影 */
  border-color: #000; /* 黑色边框 */
  box-shadow: inset 0 0 15px rgba(0, 0, 0, 0.2), 0 6px 15px rgba(0, 0, 0, 0.2); /* 鼠标悬停时增加内阴影 */
  cursor: pointer;
}
.news_img {
  width: 30%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.news_img img {
  width: 100%;
  height: 280px;
  border-radius: 10px 10px 10px 10px; /* 图片左上角和左下角圆角 */
}

.title_content {
  padding: 15px; /* 添加内边距 */
  border-radius: 0 10px 10px 0; /* 标题和内容区域的右上角和右下角圆角 */
  border-left: 1px solid #ccccccf8;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-around;
}
.gutter {
  width: 88%;
  margin: 0 auto;
  font-size: 20px;
  position: relative; /* 确保伪元素相对于这个容器定位 */
}

.company_news_1 {
  position: relative; /* 确保伪元素可以相对于这个元素定位 */
  display: inline-block; /* 确保元素的宽度与其内容相匹配 */
  color: #333; /* 文本颜色 */
  padding-bottom: 5px; /* 为下面的线留出空间 */
  margin-bottom: 20px;
}
.company_news_1:hover {
  cursor: pointer;
}

.company_news_1::after {
  content: ""; /* 伪元素的内容为空 */
  position: absolute; /* 绝对定位 */
  left: 0; /* 从左侧开始 */
  bottom: 0; /* 在元素底部 */
  height: 2px; /* 线的高度 */
  width: 100%; /* 线的宽度与元素宽度相同 */
  background-color: blue; /* 线的颜色 */
}
.line {
  border-bottom: 2px solid #ccc;
  margin-bottom: 50px;
}
.title {
  display: flex;
  flex-direction: row;
  margin-bottom: 50px;
  width: 180px;
  margin: 0 auto;
  justify-content: space-between;
  /* margin-bottom: 20px; */
  margin-top: 30px;
  font-size: 20px;
}

.title div {
  cursor: pointer; /* 表明元素可点击 */
  padding: 5px 0; /* 为文本添加一些垂直内边距 */
  position: relative; /* 为伪元素定位做准备 */
  transition: all 0.3s ease; /* 添加过渡效果 */
}

.title div:after {
  content: ""; /* 伪元素内容为空 */
  position: absolute; /* 绝对定位 */
  left: 0; /* 从左侧开始 */
  bottom: 0; /* 在元素底部 */
  height: 1px; /* 高度为1px */
  width: 0; /* 初始宽度为0 */
  background-color: #ccc; /* 灰线颜色 */
  transition: width 0.3s ease; /* 添加过渡效果 */
}

.title div:active,
.title div:focus {
  outline: none; /* 移除点击时的默认轮廓 */
}

.title div:active:after,
.title div:focus:after {
  width: 100%; /* 点击或聚焦时，伪元素宽度为100% */
  background-color: blue; /* 蓝线颜色 */
}

/* 可选：为鼠标悬停时添加样式 */
.title div:hover:after {
  width: 100%;
  background-color: blue;
}
</style>
